import { Component, HostListener, inject, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { InteresseDialogService } from './interesse-dialog.service';
import { ComunicacaoService } from '../../core/services/comunicacao.service';
import { AuthService } from '../../core/services/auth.service';
import { I18nService } from '../../core/services/i18n.service';
import { TranslatePipe } from '../pipes/translate.pipe';
import { WyLoaderComponent } from '../loader/loader';

@Component({
  selector: 'app-interesse-dialog',
  standalone: true,
  imports: [FormsModule, TranslatePipe, WyLoaderComponent],
  templateUrl: './interesse-dialog.html',
})
export class InteresseDialogComponent {
  protected readonly dialog = inject(InteresseDialogService);
  private readonly comunicacao = inject(ComunicacaoService);
  private readonly auth = inject(AuthService);
  private readonly i18n = inject(I18nService);

  protected mensagem = '';
  protected readonly enviando = signal(false);
  protected readonly enviado = signal(false);
  protected readonly erro = signal('');

  @HostListener('document:keydown.escape')
  onEscape(): void {
    if (this.dialog.recurso()) this.close();
  }

  protected close(): void {
    this.dialog.fechar();
    this.mensagem = '';
    this.enviado.set(false);
    this.erro.set('');
  }

  protected onOverlayClick(event: MouseEvent): void {
    if ((event.target as HTMLElement).dataset['overlay']) this.close();
  }

  protected async enviar(): Promise<void> {
    const recurso = this.dialog.recurso();
    if (!recurso || this.enviando()) return;
    this.enviando.set(true);
    this.erro.set('');
    try {
      const attrs = await this.auth.getUserAttributes();
      await this.comunicacao.enviarContato({
        nome: attrs.name || attrs.email,
        email: attrs.email,
        assunto: `${this.i18n.t('interesse.assunto')}: ${recurso}`,
        mensagem: this.mensagem.trim() || this.i18n.t('interesse.mensagemPadrao'),
      });
      this.enviado.set(true);
    } catch (err) {
      this.erro.set((err as { message?: string })?.message ?? this.i18n.t('interesse.erro'));
    } finally {
      this.enviando.set(false);
    }
  }
}
